var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.039,
    height: 21.407,
    viewBox: "0 0 18.039 21.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-logout-3613498",
    transform: "translate(-73.265 -26.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37621",
    "data-name": "Path 37621",
    d: "M150.467,36.949a.369.369,0,0,1,.369-.369h5.906V27.832a1.586,1.586,0,0,0-1.581-1.587h-8.649a1.586,1.586,0,0,0-1.583,1.587V46.065a1.586,1.586,0,0,0,1.583,1.587h8.649a1.586,1.586,0,0,0,1.583-1.587V37.318h-5.906a.369.369,0,0,1-.371-.369Z",
    transform: "translate(-71.663 0)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37622",
    "data-name": "Path 37622",
    d: "M430.888,193.019l-2.746-2.752a.369.369,0,1,0-.523.521l2.746,2.752c.013.013.024.026.035.039h-5.377v.738h5.262l-2.737,2.742h0a.369.369,0,1,0,.523.522l2.817-2.823a1.227,1.227,0,0,0,.354-.764.168.168,0,0,1,0-.034,1.229,1.229,0,0,0-.357-.942Z",
    transform: "translate(-339.943 -156.999)",
    fill: "#61277f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogout);
export default __webpack_public_path__ + "static/media/sidebar-logout.a93ffa73086bc7b303293dcd330d57d0.svg";
export { ForwardRef as ReactComponent };